<template>
  <div v-if="false" class="visit-tracker"></div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { visitTracker } from '@/utils/visitTracker'

const route = useRoute()
const router = useRouter()

const trackPageLeave = () => {
  visitTracker.trackDuration()
}

onMounted(() => {
  visitTracker.trackPageView(route.path, route.meta?.title as string)
  
  router.afterEach((to) => {
    visitTracker.trackPageView(to.path, to.meta?.title as string)
  })
})

onUnmounted(() => {
  trackPageLeave()
})
</script>

<style scoped>
.visit-tracker {
  display: none;
}
</style>
